module.exports = __webpack_public_path__ + "img/MarioMalz_140x140_rund.f995866f.jpg";